export default function GS_Syntax() {
  return (
    <div className="p-4">
      <h1>GS Syntax</h1>
    </div>
  );
}
